/* Sublimations-Sortiment: Ketten-Auswahl, Handy-Wechsel, Vorbestellpreis, "Dein Handy". Stand 10.10.2026 */
(function () {
  'use strict';
  if (window.__skSortiment) return;   /* nie doppelt: sonst zählt jeder Klick zweimal */
  window.__skSortiment = true;
  var KEY = 'sk_handy';
  function lies() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function merke(slug, label) { try { localStorage.setItem(KEY, JSON.stringify({ slug: slug, label: label })); } catch (e) {} }
  function eur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* ---- Messen: jeder Klick auf den Hüllen-Seiten ----
     1) dataLayer-Event "sk_klick" (nur falls je ein GTM dazukommt; aktuell kein GTM auf der Seite)
     2) Microsoft Clarity: Event + Tags (sofort filterbar, Heatmaps/Aufnahmen)
     3) Shopify Kundenereignis "sk_klick" -> Custom Pixel -> GA4 (docs/skalierung/sk-klick-pixel.md)
     Läuft nur, was geladen ist (Cookie-Zustimmung wird von den Tools selbst beachtet). */
  var ctxEl = document.querySelector('[data-sk-kontext]');
  var KONTEXT = ctxEl ? { seite: ctxEl.getAttribute('data-sk-kontext'), muster: ctxEl.getAttribute('data-sk-muster') || '', modell: ctxEl.getAttribute('data-sk-modell') || '' } : { seite: '', muster: '', modell: '' };
  function messen(aktion, wert, extra) {
    var d = { sk_aktion: aktion, sk_wert: wert || '', sk_seite: KONTEXT.seite, sk_muster: KONTEXT.muster, sk_modell: KONTEXT.modell };
    if (extra) for (var k in extra) d[k] = extra[k];
    try { window.dataLayer = window.dataLayer || []; d.event = 'sk_klick'; window.dataLayer.push(d); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('event', 'sk_' + aktion); if (wert) window.clarity('set', 'sk_' + aktion, String(wert)); } } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('sk_klick', d); } catch (e) {}
  }
  window.skMessen = messen;   /* auch für sk-foto.js */
  /* Seitenaufruf mit Kontext taggen (Clarity: Sitzungen nach Seite/Muster/Modell filtern) */
  if (KONTEXT.seite) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'sk_seite', KONTEXT.seite);
        if (KONTEXT.muster) window.clarity('set', 'sk_muster', KONTEXT.muster);
        if (KONTEXT.modell) window.clarity('set', 'sk_modell', KONTEXT.modell);
      }
    } catch (e) {}
  }
  /* Klicks auf Links/Kacheln mit data-sk-mess="aktion" (Wert = data-sk-mess-wert oder Linktext) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sk-mess]');
    if (a) messen(a.getAttribute('data-sk-mess'), a.getAttribute('data-sk-mess-wert') || (a.textContent || '').trim().slice(0, 40));
  }, true);

  /* ---- Produktseite: Handy merken + "Anderes Handy?" ---- */
  var sel = document.querySelector('[data-sk-switch]');
  if (sel) {
    var opt = sel.options[sel.selectedIndex];
    if (opt) merke(opt.value, opt.text);
    sel.addEventListener('change', function () {
      messen('modell_wechsel', sel.value);
      var design = sel.getAttribute('data-sk-switch');
      var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
      window.location.href = root + 'products/handyhuelle-' + design + '-' + sel.value;
    });
  }

  /* ---- Produktseite: späterer Preis folgt der gewählten Ausführung ---- */
  var preisData = document.querySelector('[data-sk-varianten]');
  var normal = document.querySelector('[data-sk-normalpreis]');
  if (preisData && normal) {
    var map = {};
    try { map = JSON.parse(preisData.textContent); } catch (e) {}
    var letzte = null;
    var setze = function (id) {
      if (map[id]) normal.textContent = eur(map[id]);
      if (letzte !== null && String(id) !== String(letzte)) messen('ausfuehrung', String(id));
      letzte = id;
    };
    if (window.eventBus) {
      window.eventBus.on('variant:updated', function (e) { if (e && e.variant) setze(e.variant.id); });
      window.eventBus.on('variant:change', function (e) { if (e && e.variant) setze(e.variant.id); });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setze(e.target.value);
    });
  }

  /* ---- Foto-Hülle: Liefertermin je Modell (lagernde Rohlinge = Versand in 1–2 Werktagen) ---- */
  var termin = document.querySelector('[data-sk-termin]');
  var lagerData = document.querySelector('[data-sk-lager]');
  if (termin && lagerData) {
    var lagerMap = {};
    try { lagerMap = JSON.parse(lagerData.textContent); } catch (e) {}
    var zeigeTermin = function (id) {
      termin.textContent = termin.getAttribute(lagerMap[String(id)] ? 'data-sk-termin-lager' : 'data-sk-termin');
    };
    if (window.eventBus) {
      window.eventBus.on('variant:updated', function (e) { if (e && e.variant) zeigeTermin(e.variant.id); });
      window.eventBus.on('variant:change', function (e) { if (e && e.variant) zeigeTermin(e.variant.id); });
    }
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') zeigeTermin(e.target.value); });
  }

  /* ---- Ketten-Auswahl ---- */
  var box = document.querySelector('[data-sk-ketten]');
  var gewaehlt = null;
  if (box) {
    var info = box.querySelector('[data-sk-gewaehlt]');
    /* Kategorie-Knöpfe aus den vorhandenen Listen bauen (leere Kategorien gibt es nicht) */
    box.querySelectorAll('[data-sk-panel-art]').forEach(function (panel) {
      var leiste = panel.querySelector('[data-sk-kats]');
      if (!leiste) return;
      panel.querySelectorAll('[data-sk-liste]').forEach(function (l, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'sk-kat'; b.setAttribute('data-sk-kat', l.getAttribute('data-sk-liste'));
        b.textContent = l.getAttribute('data-sk-name');
        leiste.appendChild(b);
      });
    });
    var zeigeKat = function (panel, kat) {
      panel.querySelectorAll('[data-sk-kat]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-sk-kat') === kat); });
      panel.querySelectorAll('[data-sk-liste]').forEach(function (l) { l.hidden = l.getAttribute('data-sk-liste') !== kat; });
    };
    var zeigeArt = function (art) {
      box.querySelectorAll('[data-sk-art]').forEach(function (b) {
        var on = b.getAttribute('data-sk-art') === art;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      box.querySelectorAll('[data-sk-panel-art]').forEach(function (p) {
        var on = p.getAttribute('data-sk-panel-art') === art; p.hidden = !on;
        if (on && p.querySelector('[data-sk-kats]') && !p.querySelector('[data-sk-kat].is-on')) {
          var erste = p.querySelector('[data-sk-liste]');
          if (erste) zeigeKat(p, erste.getAttribute('data-sk-liste'));
        }
      });
      waehle(null); /* Wechsel Ohne/Lang/Kurz = neue Wahl, keine versteckte Kette im Warenkorb */
    };
    /* Gibt es für "Lang" oder "Kurz" gar keine Ketten, verschwindet der Knopf */
    ['lang', 'kurz'].forEach(function (art) {
      var p = box.querySelector('[data-sk-panel-art="' + art + '"]');
      var b = box.querySelector('[data-sk-art="' + art + '"]');
      if (p && b && !p.querySelector('[data-sk-liste]')) b.hidden = true;
    });
    var waehle = function (btn) {
      box.querySelectorAll('[data-sk-kette]').forEach(function (k) {
        var on = k === btn; k.classList.toggle('is-on', on); k.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      gewaehlt = btn ? { id: btn.getAttribute('data-sk-kette'), name: btn.getAttribute('data-name'), preis: +btn.getAttribute('data-preis') } : null;
      if (info) {
        info.hidden = !gewaehlt;
        if (gewaehlt) info.textContent = 'Dazu: ' + gewaehlt.name + ' (+ ' + eur(gewaehlt.preis) + ') · zusammen versandkostenfrei';
      }
    };
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sk-art]'); if (a) { zeigeArt(a.getAttribute('data-sk-art')); messen('kette_art', a.getAttribute('data-sk-art')); return; }
      var k = e.target.closest('[data-sk-kat]'); if (k) { zeigeKat(k.closest('[data-sk-panel-art]'), k.getAttribute('data-sk-kat')); messen('kette_kategorie', k.getAttribute('data-sk-kat')); return; }
      var c = e.target.closest('[data-sk-kette]');
      if (c) {
        var weg = c.classList.contains('is-on');
        waehle(weg ? null : c);
        messen(weg ? 'kette_abgewaehlt' : 'kette_gewaehlt', c.getAttribute('data-name'), { sk_preis: (+c.getAttribute('data-preis') || 0) / 100 });
      }
    });

    /* Hülle + Kette zusammen in den Warenkorb (nur wenn eine Kette gewählt ist) */
    /* Das Formular, zu dem der Warenkorb-Button gehört (NICHT das Raten-/Installment-Formular) */
    var addBtn = document.querySelector('product-form [name="add"], form[action*="/cart/add"] [name="add"]');
    var form = addBtn ? (addBtn.form || addBtn.closest('form')) : null;
    var sendeBeide = function (e) {
      if (!gewaehlt || !form) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var idEl = form.querySelector('[name="id"]');
      var qEl = form.querySelector('[name="quantity"]') || (form.id && document.querySelector('[name="quantity"][form="' + form.id + '"]'));
      var menge = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      var drawer = (document.getElementById('PageContainer') || {}).dataset && document.getElementById('PageContainer').dataset.cartType === 'drawer';
      /* "_"-Merkmale sieht die Kundin nicht, wir aber in jeder Bestellung -> Mitkauf-Quote aus Shopify */
      var quelle = KONTEXT.muster ? (KONTEXT.muster + ' · ' + KONTEXT.modell) : 'foto-huelle';
      /* Hülle mit eigenem Foto: Datei-Felder gehen nur per FormData (multipart) mit -> erst Hülle, dann Kette */
      var mitDatei = Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (f) { return f.files && f.files.length; })
        || Array.prototype.some.call(document.querySelectorAll('input[type="file"][form="' + form.id + '"]'), function (f) { return f.files && f.files.length; });
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      var kette = { id: +gewaehlt.id, quantity: 1, properties: { _sk_quelle: 'kette-zur-huelle', _sk_huelle: quelle } };
      var antwort = function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); };
      var anfrage;
      if (mitDatei) {
        var fd = new FormData(form);
        fd.set('quantity', String(menge));
        anfrage = fetch(url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(antwort)
          .then(function () {
            var b2 = { items: [kette] }; if (drawer) b2.sections = 'cart-drawer';
            return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b2) });
          }).then(antwort);
      } else {
        var body = { items: [
          { id: +idEl.value, quantity: menge, properties: { _sk_quelle: 'huelle-mit-kette' } },
          kette
        ] };
        if (drawer) body.sections = 'cart-drawer';
        anfrage = fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(antwort);
      }
      messen('bundle_warenkorb', gewaehlt.name, { sk_preis: gewaehlt.preis / 100 });
      var knopf = form.querySelector('[name="add"]'); if (knopf) knopf.setAttribute('aria-busy', 'true');
      anfrage
        .then(function (j) {
          if (drawer && window.eventBus) {
            window.eventBus.emit('update:cart:drawer', j);
            window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
            fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then(function (r) { return r.json(); })
              .then(function (cart) { if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart); }).catch(function () {});
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          if (info) { info.hidden = false; info.textContent = (err && err.description) || 'Das hat nicht geklappt. Bitte versuche es noch einmal.'; }
        })
        .finally(function () { if (knopf) knopf.removeAttribute('aria-busy'); });
    };
    /* document + capture: läuft vor dem Theme-Handler (component-product-form.js) */
    if (form) document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!gewaehlt) messen('warenkorb_nur_huelle', '');
      sendeBeide(e);
    }, true);
  }

  /* ---- Musterseite: Modell-Dropdown + "Dein Handy" ---- */
  document.querySelectorAll('[data-sk-modellwahl]').forEach(function (w) {
    var sel2 = w.querySelector('select[data-sk-ziel]');
    var los = w.querySelector('[data-sk-los]');
    if (!sel2) return;
    var ziel = function () { return sel2.getAttribute('data-sk-ziel') + sel2.value; };
    var aktiv = function () {
      if (!los) return;
      var ok = !!sel2.value; los.setAttribute('aria-disabled', ok ? 'false' : 'true'); los.href = ok ? ziel() : '#';
    };
    var mein = lies();
    if (mein && sel2.querySelector('option[value="' + mein.slug + '"]')) {
      sel2.value = mein.slug; aktiv();
      var hinweis = document.querySelector('[data-sk-mein]');
      if (hinweis) { hinweis.hidden = false; hinweis.querySelector('a').href = ziel(); hinweis.querySelector('[data-sk-mein-name]').textContent = mein.label; }
    }
    sel2.addEventListener('change', function () {
      messen('modell_dropdown', sel2.value);
      aktiv();
      if (sel2.value) window.location.href = ziel();
    });
  });
  document.querySelectorAll('.sk-alle-modelle').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) messen('modellliste_offen', ''); });
  });
  var mein2 = lies();
  if (mein2) document.querySelectorAll('.sk-modelle [data-sk-slug="' + mein2.slug + '"]').forEach(function (a) { a.classList.add('is-mein'); });
})();
